import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './InteractionContainer.scss';

const defaultProps = {
  components: [],
  className: '',
};

const InteractionContainer = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { components, className } = mergedProps;
  return (
    <Box display='flex' flexDirection='row' flexWrap='wrap' className={`setting-section-container ${className}`} data-test='interaction-section'>
      {components.map((entry, index) => (
        <Box
          className={`${entry.className}`}
          p={1}
          key={`setting-section-container-entry-${index}`}
          data-test={`interaction-${entry.title.toLowerCase().replace(/ /g, '-')}`}
        >
          <Box display='flex' mr='15px' alignItems='center'>
            <Typography variant='subtitle1' className='setting-section-container-title nested'>
              {entry.title}
            </Typography>
            {entry.tooltip}
          </Box>
          {entry.component}
        </Box>
      ))}
    </Box>
  );
};

export default InteractionContainer;
